import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cards",
  "use": "cards-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"cards\"><path d=\"M0 0h24v24H0z\" fill=\"none\" /><path d=\"M11.37 3c-.26 0-.52.06-.77.15L3.24 6.2a1.994 1.994 0 0 0-1.09 2.6l4.96 11.95A2 2 0 0 0 8.92 22c.26 0 .53-.03.79-.15l7.37-3.05a2.02 2.02 0 0 0 1.23-1.8c.01-.25-.04-.54-.13-.8l-5-11.95A1.954 1.954 0 0 0 11.37 3m3.48 0 3.45 8.35V5a2 2 0 0 0-2-2m4.01 1.54v9.03l2.43-5.86a1.99 1.99 0 0 0-1.09-2.6m-10.28-.14 4.98 12.02-7.39 3.06L3.98 8.04\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol